var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashapp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 53 53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#cash-app)",
    d: "M47 0H6C2.6863 0 0 2.6863 0 6v41c0 3.3137 2.6863 6 6 6h41c3.3137 0 6-2.6863 6-6V6c0-3.3137-2.6863-6-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.6834 18.4165c2.2161.008 4.3585.8271 6.0506 2.3131.1754.1654.4051.2549.6419.2502.2369-.0047.4632-.1031.6324-.2753l1.7268-1.8218a.9323.9323 0 00.2018-.3171.961.961 0 00-.0245-.7437.9258.9258 0 00-.2222-.302c-1.367-1.2072-2.9469-2.1268-4.6519-2.7077l.5456-2.6789a.9798.9798 0 00-.0075-.4151.9579.9579 0 00-.1785-.3715.9147.9147 0 00-.3148-.2559.8803.8803 0 00-.3902-.0908h-3.3706a.8941.8941 0 00-.5738.2094.9566.9566 0 00-.3207.5365l-.4904 2.3813c-4.4895.2296-8.2884 2.532-8.2884 7.2515 0 4.0848 3.1392 5.8349 6.4581 7.0471 3.1392 1.2122 4.7969 1.6605 4.7969 3.3675 0 1.7071-1.6577 2.783-4.0993 2.783-2.3706.0389-4.6607-.8925-6.3752-2.5929-.171-.173-.4002-.2699-.6389-.2699-.2387 0-.468.0969-.6389.2699l-1.8753 1.9007a.9409.9409 0 00-.2044.3089.971.971 0 000 .7344.9415.9415 0 00.2044.3088c1.5258 1.4948 3.391 2.5645 5.422 3.1093l-.5042 2.4925a1.0043 1.0043 0 00.0066.4189.9842.9842 0 00.1764.3769.9402.9402 0 00.3132.2641.9038.9038 0 00.3914.102h3.3948a.8903.8903 0 00.5786-.2063.953.953 0 00.3228-.5396l.4869-2.3885c5.3633-.3586 8.6338-3.3388 8.6338-7.732 0-4.0382-3.2739-5.7381-7.2524-7.1368-2.269-.8535-4.2306-1.4345-4.2306-3.1882s1.8339-2.392 3.6677-2.392z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "cash-app",
    x1: 0,
    x2: 53,
    y1: 26.5,
    y2: 26.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C244"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D64B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashapp);
export default __webpack_public_path__ + "static/media/cashapp.2c320d7473e0fbd2ca6966c4c18338ae.svg";
export { ForwardRef as ReactComponent };